// src/aggrid/columnDefs.ts
import { ColDef } from 'ag-grid-community';
import { AddressCellRenderer } from './cellRenderers/AddressCellRenderer';
import { TransactionHashCellRenderer } from './cellRenderers/TransactionHashCellRenderer';
import { BlockCellRenderer } from './cellRenderers/BlockCellRenderer';
import { TimestampCellRenderer } from './cellRenderers/TimestampCellRenderer';
import { AmountCellRenderer } from './cellRenderers/AmountCellRenderer';
import { AssetCellRenderer } from './cellRenderers/AssetCellRenderer';

// Common columns
const hashColDef: ColDef = {
  field: 'txid',
  headerName: 'Transaction Hash',
  width: 200,
  headerClass: 'font-bold',
  cellRenderer: TransactionHashCellRenderer,
};

const blockColDef: ColDef = {
  field: 'block',
  headerName: 'Block',
  width: 150,
  sortable: true,
  headerClass: 'font-bold',
  cellRenderer: BlockCellRenderer,
};

const timestampColDef: ColDef = {
  field: 'timestamp',
  headerName: 'Time',
  width: 180,
  sortable: true,
  headerClass: 'font-bold',
  cellRenderer: TimestampCellRenderer,
};

const fromColDef: ColDef = {
  field: '_from',
  headerName: 'From',
  flex: 1,
  headerClass: 'font-bold',
  cellRenderer: AddressCellRenderer,
  cellRendererParams: {
    columnId: 'from',
  },
};

const toColDef: ColDef = {
  field: '_to',
  headerName: 'To',
  flex: 1,
  headerClass: 'font-bold',
  cellRenderer: AddressCellRenderer,
  cellRendererParams: {
    columnId: 'to',
  },
};

const amountColDef: ColDef = {
  field: 'amount',
  headerName: 'Amount',
  flex: 1,
  sortable: true,
  headerClass: 'font-bold',
  cellRenderer: AmountCellRenderer,
};

const assetColDef: ColDef = {
  field: 'tokenMetadata',
  headerName: 'Asset',
  width: 150,
  headerClass: 'font-bold',
  cellRenderer: AssetCellRenderer,
};

export const combinedColDefs: ColDef[] = [
  hashColDef,
  blockColDef,
  timestampColDef,
  fromColDef,
  toColDef,
  amountColDef,
  assetColDef,
];
